<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الفصل-الأول">
<h1></h1>
<h1 style="font-family:Dubai"><span dir="rtl">الفصل الأول</span></h1>
<p style="text-align: center;"><img alt="" src="media/file2.png" style="width:1.80208in;height:1.80208in"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?74d14048